module.exports = __webpack_public_path__ + "img/onetime-passcode-icon.7316c58b.svg";